<!-- TrustPilot -->
@if (linkData) {
  <bdo-coop-teaser
    [title]="'confirmation.rating.title' | translate"
    [iconSrc]="'assets/img/reviewus-sticker-2.svg'"
    [linkData]="linkData"
    >
    <span [innerHTML]="'confirmation.rating.description' | translate"></span>
  </bdo-coop-teaser>
}
